import React from "react";
// Make sure this path is correct based on your project structure
import dummy1 from "../SignificanceOfNarasimha/assets/dummy1.jpg";
import NarasimhaChaturdhashi from "../SignificanceOfNarasimha/assets/Narasimha Chaturdhashi.png";
import NityaSeva from "../NityaSevaBlog/assets/Nitya Seva.png";
import Ekadashi from "../EkadashiImportance/assets/Ekadashi.png";
import Radhayatra from "../SriJagannathRathYatra/assets/Radhayatra.png";
import { NavLink } from "react-router-dom";
import "./recentBlogs.css";

const RecentBlogs = () => {
  return (
    <div id="recent-sidebar-container">
      {" "}
      {/* Main container for the sidebar */}
      <h1 className="recent-events">Recent Events</h1>
      <div id="recent-card-grid">
        {" "}
        {/* Grid container for the recent blog cards */}
        <div className="recent-card">
          <div className="image-wrapper-recent-blog">
            <img
              src={NarasimhaChaturdhashi}
              alt="Significance of Narasimha Chaturdashi"
            />
          </div>
          <h3>Significance-of-Narasimha Chaturdashi</h3>
          <p>
            Each year, the Vaishnava community around the world reverently
            celebrates Narasimha Chaturdashi, also known as Lord Narasimha
            Jayanti, the divine appearance day of Lord Narasimhadeva......
          </p>
          <NavLink to="/significance-of-narasimha" className="no-underline">
            <button className="read-more-btn">READ MORE</button>
          </NavLink>
        </div>
        <div className="recent-card">
          <div className="image-wrapper-recent-blog">
            <img src={NityaSeva} alt="Nitya Seva Festival" />
          </div>
          <h3>Nitya Seva</h3>
          <p>
            Have you ever wondered how beautifully everything is organized
            during ISKCON Vijayawada temple festivals—be it the altar decoration
            seva, preparation of prasadam, spiritual lectures......
          </p>
          <NavLink to="/nitya-seva-blog" className="no-underline">
            <button className="read-more-btn">READ MORE</button>
          </NavLink>
        </div>
        <div className="recent-card">
          <div className="image-wrapper-recent-blog">
            <img src={Ekadashi} alt="Ekadashi Importance Festival" />
          </div>
          <h3>Ekadashi Importance</h3>
          <p>
            Every month, there is a special day known as Ekadashi that holds
            great importance for devotees of Lord Vishnu. Ekadashi, the 11th
            lunar day (both of the waxing Amavasya and waning Pournami moon
            phases......
          </p>
          <NavLink to="/ekadashi-importance" className="no-underline">
            <button className="read-more-btn">READ MORE</button>
          </NavLink>
        </div>
        <div className="recent-card">
          <div className="image-wrapper-recent-blog">
            <img src={Radhayatra} alt="Ekadashi Importance Festival" />
          </div>
          <h3>Sri Jagannath Rath Yatra</h3>
          <p>
            ISKCON Vijayawada celebrates Sri Jagannath Rath Yatra with grandeur,
            uniting devotees in a joyful procession of devotion, music, and
            spiritual festivity.
          </p>
          <NavLink to="/ekadashi-importance" className="no-underline">
            <button className="read-more-btn">READ MORE</button>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default RecentBlogs;
